// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Control_Monad_Replace from "../Control.Monad.Replace/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Specular_Internal_Effect from "../Specular.Internal.Effect/index.js";
import * as Specular_Internal_RIO from "../Specular.Internal.RIO/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var sequence_ = /* #__PURE__ */ Data_Foldable.sequence_(Effect.applicativeEffect)(Data_Foldable.foldableArray);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var Host = function (x) {
    return x;
};
var runHost = function (v) {
    return function __do() {
        var actionsMutable = Specular_Internal_Effect.emptyDelayed();
        var result = Specular_Internal_RIO.runRIO(actionsMutable)(v)();
        var actions = Specular_Internal_Effect.unsafeFreezeDelayed(actionsMutable)();
        return new Data_Tuple.Tuple(result, Specular_Internal_Effect.sequenceEffects(actions));
    };
};
var monadHost = Specular_Internal_RIO.monadRIO;
var monadCleanupHost = {
    onCleanup: function (action) {
        return function (actions) {
            return Specular_Internal_Effect.pushDelayed(actions)(action)();
        };
    },
    Monad0: function () {
        return monadHost;
    }
};
var onCleanup = /* #__PURE__ */ Control_Monad_Cleanup.onCleanup(monadCleanupHost);
var monadEffectHost = Specular_Internal_RIO.monadEffectRIO;
var liftHost = function (dictMonadCleanup) {
    var Monad0 = dictMonadCleanup.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind1 = Control_Bind.bind(Bind1);
    var discard3 = discard(Bind1);
    var onCleanup1 = Control_Monad_Cleanup.onCleanup(dictMonadCleanup);
    var pure2 = Control_Applicative.pure(Monad0.Applicative0());
    return function (dictMonadEffect) {
        var liftEffect = Effect_Class.liftEffect(dictMonadEffect);
        return function (m) {
            return bind1(liftEffect(runHost(m)))(function (v) {
                return discard3(onCleanup1(v.value1))(function () {
                    return pure2(v.value0);
                });
            });
        };
    };
};
var functorHost = Specular_Internal_RIO.functorRIO;
var bindHost = Specular_Internal_RIO.bindRIO;
var discard2 = /* #__PURE__ */ discard(bindHost);
var applyHost = Specular_Internal_RIO.applyRIO;
var applicativeHost = Specular_Internal_RIO.applicativeRIO;
var pure1 = /* #__PURE__ */ Control_Applicative.pure(applicativeHost);
var $lazy_monadReplaceHost = /* #__PURE__ */ $runtime_lazy("monadReplaceHost", "Specular.FRP.Host", function () {
    return {
        newSlot: Control_Bind.bind(bindHost)(Effect_Class.liftEffect(monadEffectHost)(Effect_Ref["new"]([  ])))(function (cleanupsRef) {
            var destroy = function __do() {
                var cleanups = Effect_Ref.read(cleanupsRef)();
                Effect_Ref.write([  ])(cleanupsRef)();
                return sequence_(cleanups)();
            };
            var append$prime = function (m) {
                return function __do() {
                    var v = runHost(m)();
                    Effect_Ref.modify_(function (v1) {
                        return append(v1)([ v.value1 ]);
                    })(cleanupsRef)();
                    return v.value0;
                };
            };
            return discard2(onCleanup(destroy))(function () {
                return pure1(new Control_Monad_Replace.Slot(function (m) {
                    return function __do() {
                        destroy();
                        return append$prime(m)();
                    };
                }, destroy, append$prime(Control_Monad_Replace.newSlot($lazy_monadReplaceHost(0)))));
            });
        }),
        Monad0: function () {
            return monadHost;
        },
        MonadCleanup1: function () {
            return monadCleanupHost;
        }
    };
});
var monadReplaceHost = /* #__PURE__ */ $lazy_monadReplaceHost(37);
export {
    Host,
    runHost,
    liftHost,
    functorHost,
    applyHost,
    applicativeHost,
    bindHost,
    monadHost,
    monadEffectHost,
    monadCleanupHost,
    monadReplaceHost
};
